// EYE PATHS : geometry lifted from EyeTunnel_rect--has_eye.svg (the
// "Eye" / "Eye_Filled" groups), shared by the CenterEye component and the
// fluid-bg melt rasterizer (src/utils/fluidBgEye.js). Coordinates live in
// the original 1920x1080 viewBox space — use the EYE_VIEWBOX crops.

export const EYE_VIEWBOX = '898 444 78 38';
export const EYE_VIEWBOX_DRIP = '898 444 78 68';

export const DRIP_D = `M906.9,469.1c1.87,1.32,2.84,10.15,1.87,12.79c-0.98,2.64-0.84,6.05,2.39,6.42
  c3.23,0.37,4.99-2.28,3.9-4.91c-1.6-3.84,3.1-4.91,4.34-3.93c1.75,1.38,2.26,2.84,2.92,5.53c0.44,1.78,0.43,3.58-1.33,6.42
  c-2.24,3.62-1.24,9.28,2.94,9.17c3.85-0.1,6.79-4.16,4.06-8.01c-1.25-1.77-1.62-5.17-0.89-7.05c1.33-3.39,4.08-3.48,5.14-1.43
  c1.28,2.48-0.83,3.92,0.27,5.98c1.16,2.17,3.45,1.92,4.96,0.54c1.93-1.76-0.69-4.51,2.75-4.91c2.3-0.27,2.42,2.65,1.51,4.73
  c-1.22,2.77-0.38,5.95,2.66,6.42c5.25,0.83,7-3.93,5.49-7.4c-1.12-2.58-0.75-7.73,2.3-7.67c3.05,0.06,5.56,3.57,5.41,9.9
  c-0.18,7.32-4.97,8.63-3.9,12.94c0.89,3.57,6.13,4.7,9.13,3.66c2.3-0.8,4.91-6.35,1.95-9.19c-3.02-2.89-3.77-10.76-3.19-14.63
  c0.52-3.52,1.86-10.86,6.49-14.5`;

export const BODY_D = `M903.81,463.94c7.51-5.41,21-12.85,32.48-12.85c14.59,0,22.71,5.16,34,13.09
  c6.3,4.42-16.79,12.84-32.47,13.4c-10.57,0.37-29.64-7.74-34.09-10.87`;

export const PUPIL_D = `M947.71,454.71c3.28,2.15,2.41,9.91-4.19,13.31c-5.4,2.78-12.83,1.37-15.83-2.97
  c-3.05-4.41-2.04-8.94,0.42-10.39c1.7-1.01,4.89-1.72,8.99-1.77C941.32,452.83,945.81,453.46,947.71,454.71z`;

export const IRIS_D = `M939.39,456.89c2.25,0.78,1.95,3.39,1.68,4.37c-0.26,0.96-1.15,2.36-2.3,2.72
  c-0.99,0.31-2.99,0.24-4.05-0.56c-1.02-0.77-1.19-2.42-1.18-3.23c0.01-0.98,0.54-2.4,1.66-2.93
  C936.09,456.84,937.21,456.14,939.39,456.89z`;
